import { useEffect, useState } from "react";
import { BACKEND } from "@/lib/api";

let cache = null;
// Admin-configurable brand copy (see /api/public/brand). Never hard-code campaign lines in components.
export const useBrand = () => {
  const [b, setB] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    fetch(`${BACKEND}/api/public/brand`).then((r) => r.json()).then((d) => { cache = d; setB(d); }).catch(() => {});
  }, []);
  return b;
};
export const resetBrandCache = () => { cache = null; };
